export const projectData = [
  {
    title: 'Beauty Beyond Barriers',
    description: 'I leveraged my skills in JavaScript, React, Node.js, Express, and MongoDB to create an app that helps people with disabilities find accessible beauty products. I worked collaboratively with my team, utilizing Agile and Scrum methodologies, to create a successful and innovative solution.',
    image: '/images/BBB.png',
    repositoryLink: 'https://github.com/cactuspie23/beauty-beyond-barriers-front-end',
    deploymentLink: 'https://beautybeyondbarriers.netlify.app/',
  },
  {
    title: 'Create-A-Corgi',
    description: 'A fun app where users can create their very own Corgi and add it to a database. They can customize by adding accessories! Built with Mongoose, Express, Node, CSS, and Google OAuth.',
    image: '/images/cac.png',
    repositoryLink: 'https://github.com/cactuspie23/create-a-corgi',
    deploymentLink: 'https://create-a-corgi.fly.dev/',
  },
  {
    title: 'Slots of Terror',
    description: 'Slot machine game with a horrifying twist! Test your luck... if you dare. Built with HTML, CSS, and JavaScript.',
    image: '/images/sot.png',
    repositoryLink: 'https://github.com/cactuspie23/slot-machine',
    deploymentLink: 'https://slotsofterror.netlify.app/',
  },
  {
    title: 'Werk',
    description: 'An app to track your job applications and skill progress while job searching. Created with a team using Mongoose, Express, React, Node, CSS.',
    image: '/images/werkhome.png',
    repositoryLink: 'https://github.com/cactuspie23/werk-front-end',
    deploymentLink: 'https://werk-smarter.netlify.app/',
  },
  {
    title: 'Tic Tac Toe',
    description: 'The traditional game with a Halloween theme. Built with JavaScript and CSS.',
    image: '/images/ttt.png',
    repositoryLink: 'https://github.com/cactuspie23/ttt-weekend',
    deploymentLink: 'https://spooky-tic-tac-toe.netlify.app/',
  },
]